import { h, mount } from '../lib/dom.js';
import { renderShell, pageHead } from '../components/shell.js';
import { toast } from '../lib/ui.js';
import { fmtDate, dayName } from '../lib/format.js';

// Varsayılan hedef: Yaklaşan YKS. Her yıl güncellenebilir; ayrıca kullanıcı override edebilir.
const DEFAULT_EXAM = { date: '2027-06-19', label: 'YKS 2027' };
const STORAGE_KEY = 'yks.examTarget';

function getTarget() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s) {
      const t = JSON.parse(s);
      if (t && /^\d{4}-\d{2}-\d{2}$/.test(t.date)) return { date: t.date, label: t.label || DEFAULT_EXAM.label };
    }
  } catch {}
  return { ...DEFAULT_EXAM };
}
function saveTarget(t) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(t)); } catch {}
}

function diffParts(fromMs, toMs) {
  let diff = Math.max(0, toMs - fromMs);
  const days = Math.floor(diff / 86400000); diff -= days * 86400000;
  const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
  const mins = Math.floor(diff / 60000); diff -= mins * 60000;
  const secs = Math.floor(diff / 1000);
  return { days, hours, mins, secs, elapsed: fromMs > toMs };
}

function tone(days) {
  if (days > 200) return { label: 'Uzun soluklu koşu', body: 'Sağlam bir plana bağlan; büyük fark, düzenli küçük çabalardan doğar.' };
  if (days > 100) return { label: 'Ortada bir yerde', body: 'Şu an ekilen tohum sınav gününde meyvesini verir.' };
  if (days > 60)  return { label: 'Sprint zamanı yaklaşıyor', body: 'Zayıf konuları bulmak için tam zaman — ivmelen.' };
  if (days > 30)  return { label: 'Son ay', body: 'Denemeler ve tekrar. Yeni konuya başlamak yerine öğrendiğini pekiştir.' };
  if (days > 7)   return { label: 'Son hafta', body: 'Dinlenmeyi ve uykuyu göz ardı etme; zihin sınav günü zinde olmalı.' };
  if (days > 0)   return { label: 'Son günler', body: 'Sakin ol. Bu noktaya kadar yaptığın çalışma seni taşıyacak.' };
  return { label: 'Bugün', body: 'Nefes al, güven. Emeğinin karşılığını al.' };
}

export function renderCountdown({ outlet }) {
  const container = h('div');
  mount(outlet, renderShell(container));

  let target = getTarget();
  let intervalId = null;

  const render = () => {
    container.replaceChildren();
    container.appendChild(pageHead(
      'Sayaç',
      'YKS gününe kalan zaman. Motivasyonu yüksek tutmak için değil, dikkatini bugünkü göreve döndürmek için.',
    ));

    const targetMs = new Date(target.date + 'T00:00:00').getTime();
    const now = Date.now();
    const parts = diffParts(now, targetMs);
    const t = tone(parts.days);

    const daysEl = h('span', { class: 'cd-days-value' }, String(parts.days));
    const daysLbl = h('span', { class: 'cd-days-label' }, parts.elapsed ? 'gün geçti' : (parts.days === 1 ? 'gün' : 'gün'));
    const hoursEl = h('span', { class: 'cd-num' }, String(parts.hours).padStart(2, '0'));
    const minsEl  = h('span', { class: 'cd-num' }, String(parts.mins).padStart(2, '0'));
    const secsEl  = h('span', { class: 'cd-num' }, String(parts.secs).padStart(2, '0'));

    const hero = h('div', { class: 'countdown-hero' + (parts.elapsed ? ' elapsed' : (parts.days < 30 ? ' urgent' : '')) },
      h('div', { class: 'cd-eyebrow' }, target.label),
      h('div', { class: 'cd-target' },
        dayName(target.date) + ', ' + fmtDate(target.date),
      ),
      h('div', { class: 'cd-days' }, daysEl, daysLbl),
      h('div', { class: 'cd-clock' },
        h('div', { class: 'cd-unit' }, hoursEl, h('span', { class: 'cd-unit-label' }, 'saat')),
        h('span', { class: 'cd-sep' }, ':'),
        h('div', { class: 'cd-unit' }, minsEl, h('span', { class: 'cd-unit-label' }, 'dakika')),
        h('span', { class: 'cd-sep' }, ':'),
        h('div', { class: 'cd-unit' }, secsEl, h('span', { class: 'cd-unit-label' }, 'saniye')),
      ),
      h('div', { class: 'cd-tone' },
        h('div', { class: 'cd-tone-label' }, t.label),
        h('p', { class: 'cd-tone-body' }, t.body),
      ),
    );
    container.appendChild(hero);

    // Ayarlar kartı — hedef tarihi değiştir
    const dateIn = h('input', { class: 'input', type: 'date', value: target.date });
    const labelIn = h('input', { class: 'input', type: 'text', maxlength: 60, value: target.label,
      placeholder: 'Etiket (örn: YKS 2027)' });

    const settings = h('div', { class: 'card', style: { marginTop: 'var(--sp-6)' } },
      h('div', { class: 'card-head' },
        h('h3', {}, 'Hedef tarih'),
        h('span', { class: 'subtle' }, 'Yerel — yalnızca senin tarayıcında saklanır'),
      ),
      h('div', { class: 'form-grid' },
        h('div', { class: 'field' }, h('label', {}, 'Tarih'), dateIn),
        h('div', { class: 'field' }, h('label', {}, 'Etiket'), labelIn),
      ),
      h('div', { class: 'row', style: { marginTop: 'var(--sp-3)', justifyContent: 'flex-end', gap: 'var(--sp-2)' } },
        h('button', {
          class: 'btn btn-ghost',
          onclick: () => {
            localStorage.removeItem(STORAGE_KEY);
            target = getTarget();
            toast('Varsayılana döndü');
            stopTick(); render();
          },
        }, 'Varsayılana dön'),
        h('button', {
          class: 'btn btn-primary',
          onclick: () => {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(dateIn.value)) {
              toast('Geçerli bir tarih seç', { type: 'error' }); return;
            }
            target = { date: dateIn.value, label: labelIn.value.trim() || 'Sınav' };
            saveTarget(target);
            toast('Hedef güncellendi', { type: 'success' });
            stopTick(); render();
          },
        }, 'Kaydet'),
      ),
    );
    container.appendChild(settings);

    // Her saniye sadece saat/dakika/saniye + gün güncelle (tam render değil)
    stopTick();
    intervalId = setInterval(() => {
      const p = diffParts(Date.now(), targetMs);
      daysEl.textContent = String(p.days);
      hoursEl.textContent = String(p.hours).padStart(2, '0');
      minsEl.textContent = String(p.mins).padStart(2, '0');
      secsEl.textContent = String(p.secs).padStart(2, '0');
    }, 1000);
  };

  const stopTick = () => {
    if (intervalId) { clearInterval(intervalId); intervalId = null; }
  };
  // Sayfa değişince temizle
  window.addEventListener('hashchange', stopTick, { once: true });

  render();
}
